module.exports = __webpack_public_path__ + "static/media/20ECE26.0131a855.jpg";